module.exports = __webpack_public_path__ + "../resources/img/storebadge_pt.6f0ad669.png";